// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentUid: '0194ffa5-99f2-70e1-aff2-65bcf3912f15',

  endpoints: {
    returnTo: 'https://dev.client.happyland.innervycs.com',
    transbank: 'https://payments.api.happyland.innervycs.com/transbank',
    status: 'https://client.api.happyland.innervycs.com/status',
    secure: 'https://client.api.happyland.innervycs.com/secure',
    register: 'https://client.api.happyland.innervycs.com/status',
    tracking: 'https://client.api.happyland.innervycs.com/tracking',
    waiver: 'https://client.api.happyland.innervycs.com/waiver',
    mercadoPago: 'https://payments.api.happyland.innervycs.com/mercadopago',
  },
  regExForCard: /^(200|0200|0020)/,
  gtmId: 'G-ZBMPL5455Q', // ID específico para desarrollo
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
